export type ECHLDivision = "North" | "South" | "Mountain";

export interface ECHLTeam {
  id: string;
  name: string;
  abbr: string;
  city: string;
  logo: string;
  division: ECHLDivision;
  nhlAffiliate: string;
  ahlAffiliate: string;
}

// ECHL team logos from their official assets
const getECHLLogo = (teamId: string) =>
  `https://assets.leaguestat.com/echl/logos/${teamId}.png`;

export const ECHL_TEAMS: ECHLTeam[] = [
  // North Division
  { id: "adk", name: "Thunder", abbr: "ADK", city: "Adirondack", logo: getECHLLogo("390"), division: "North", nhlAffiliate: "NJD", ahlAffiliate: "UTI" },
  { id: "cin", name: "Cyclones", abbr: "CIN", city: "Cincinnati", logo: getECHLLogo("346"), division: "North", nhlAffiliate: "NYR", ahlAffiliate: "HFD" },
  { id: "ft", name: "Walleye", abbr: "TOL", city: "Toledo", logo: getECHLLogo("369"), division: "North", nhlAffiliate: "DET", ahlAffiliate: "GR" },
  { id: "ind", name: "Fuel", abbr: "IND", city: "Indy", logo: getECHLLogo("393"), division: "North", nhlAffiliate: "CHI", ahlAffiliate: "RFD" },
  { id: "kai", name: "Wings", abbr: "KAL", city: "Kalamazoo", logo: getECHLLogo("357"), division: "North", nhlAffiliate: "VAN", ahlAffiliate: "ABB" },
  { id: "nfld", name: "Growlers", abbr: "NFL", city: "Newfoundland", logo: getECHLLogo("394"), division: "North", nhlAffiliate: "TOR", ahlAffiliate: "TOR" },
  { id: "read", name: "Royals", abbr: "REA", city: "Reading", logo: getECHLLogo("350"), division: "North", nhlAffiliate: "PHI", ahlAffiliate: "LV" },
  { id: "whe", name: "Nailers", abbr: "WHL", city: "Wheeling", logo: getECHLLogo("356"), division: "North", nhlAffiliate: "PIT", ahlAffiliate: "WBS" },

  // South Division
  { id: "atl", name: "Gladiators", abbr: "ATL", city: "Atlanta", logo: getECHLLogo("395"), division: "South", nhlAffiliate: "VGK", ahlAffiliate: "HSK" },
  { id: "fla", name: "Everblades", abbr: "FLA", city: "Florida", logo: getECHLLogo("379"), division: "South", nhlAffiliate: "NSH", ahlAffiliate: "MIL" },
  { id: "grn", name: "Swamp Rabbits", abbr: "GRN", city: "Greenville", logo: getECHLLogo("392"), division: "South", nhlAffiliate: "LAK", ahlAffiliate: "ONT" },
  { id: "jax", name: "Icemen", abbr: "JAX", city: "Jacksonville", logo: getECHLLogo("396"), division: "South", nhlAffiliate: "BUF", ahlAffiliate: "ROC" },
  { id: "nor", name: "Admirals", abbr: "NOR", city: "Norfolk", logo: getECHLLogo("371"), division: "South", nhlAffiliate: "WPG", ahlAffiliate: "MB" },
  { id: "orl", name: "Solar Bears", abbr: "ORL", city: "Orlando", logo: getECHLLogo("391"), division: "South", nhlAffiliate: "TBL", ahlAffiliate: "SYR" },
  { id: "sc", name: "Stingrays", abbr: "SC", city: "South Carolina", logo: getECHLLogo("347"), division: "South", nhlAffiliate: "WSH", ahlAffiliate: "HER" },
  { id: "sav", name: "Ghost Pirates", abbr: "SAV", city: "Savannah", logo: getECHLLogo("401"), division: "South", nhlAffiliate: "VGK", ahlAffiliate: "HSK" },

  // Mountain Division
  { id: "all", name: "Americans", abbr: "ALN", city: "Allen", logo: getECHLLogo("383"), division: "Mountain", nhlAffiliate: "OTT", ahlAffiliate: "BEL" },
  { id: "idh", name: "Steelheads", abbr: "IDH", city: "Idaho", logo: getECHLLogo("382"), division: "Mountain", nhlAffiliate: "DAL", ahlAffiliate: "TEX" },
  { id: "kc", name: "Mavericks", abbr: "KC", city: "Kansas City", logo: getECHLLogo("354"), division: "Mountain", nhlAffiliate: "SEA", ahlAffiliate: "ABX" },
  { id: "rc", name: "Rush", abbr: "RC", city: "Rapid City", logo: getECHLLogo("372"), division: "Mountain", nhlAffiliate: "CGY", ahlAffiliate: "CGY" },
  { id: "tah", name: "Knight Monsters", abbr: "TAH", city: "Tahoe", logo: getECHLLogo("402"), division: "Mountain", nhlAffiliate: "VGK", ahlAffiliate: "HSK" },
  { id: "tul", name: "Oilers", abbr: "TUL", city: "Tulsa", logo: getECHLLogo("361"), division: "Mountain", nhlAffiliate: "ANA", ahlAffiliate: "SD" },
  { id: "uta", name: "Grizzlies", abbr: "UTA", city: "Utah", logo: getECHLLogo("349"), division: "Mountain", nhlAffiliate: "COL", ahlAffiliate: "COL" },
  { id: "wic", name: "Thunder", abbr: "WIC", city: "Wichita", logo: getECHLLogo("373"), division: "Mountain", nhlAffiliate: "SJS", ahlAffiliate: "SJ" },
];

export const ECHL_DIVISIONS: ECHLDivision[] = ["North", "South", "Mountain"];

export const getECHLTeamByAbbr = (abbr: string): ECHLTeam | undefined => {
  return ECHL_TEAMS.find((team) => team.abbr === abbr);
};

export const getECHLTeamsByDivision = (division: ECHLDivision): ECHLTeam[] => {
  return ECHL_TEAMS.filter((team) => team.division === division);
};
